import * as React from "react";

interface Profile {
  id: number;
  first_name: string;
  last_name: string;
  [prop: string]: any;
}

interface NameProps {
  profile: Profile;
  authenticity_token: string;
  blockedCallback: any;
  favorites?: Array<number>;
  blocked?: Array<number>;
  job_id: any;
  user_id: any;
  invite_component: any;
  isApplicant?: boolean;
  isCancelled?: boolean;
  isDeclined?: boolean;
}

function ProfileName({
  profile,
  authenticity_token,
  blockedCallback,
  favorites = [],
  blocked = [],
  job_id = undefined,
  user_id = undefined,
  invite_component = undefined,
  isApplicant = false,
  isCancelled = false,
  isDeclined = false,
}: NameProps) {
  const first_name = profile.first_name
    ? profile.first_name.charAt(0).toUpperCase() + profile.first_name.slice(1)
    : '';

  const last_name = profile.last_name
    ? profile.last_name.charAt(0).toUpperCase() + profile.last_name.slice(1)
    : '';

  return (
    <>
      <h3 style={{
        fontSize: '1.25rem',
        fontWeight: 700,
        margin: 0
      }} className="col-12 mb-0 mt-2 col-12 col-xl-6">
        <a
          href={profile.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#085ec8',
            textDecoration: 'none',
            transition: 'color 0.3s ease'
          }}
          onMouseOver={(e) => e.currentTarget.style.color = '#71ad08'}
          onMouseOut={(e) => e.currentTarget.style.color = '#085ec8'}
        >
          {first_name} {last_name}
        </a>
        {isCancelled ? (
          <span
            className="badge-modern badge-modern--danger ms-2"
            style={{
              fontSize: '0.75rem',
              padding: '0.25rem 0.75rem',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              backgroundColor: '#dc3545',
              color: 'white'
            }}
          >
            Cancelled
          </span>
        ) : isDeclined ? (
          <span
            className="badge-modern badge-modern--warning ms-2"
            style={{
              fontSize: '0.75rem',
              padding: '0.25rem 0.75rem',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              backgroundColor: '#fd7e14',
              color: 'white'
            }}
          >
            Declined
          </span>
        ) : isApplicant && (
          <span
            className="badge-modern badge-modern--success ms-2"
            style={{
              fontSize: '0.75rem',
              padding: '0.25rem 0.75rem',
              fontWeight: 600,
              whiteSpace: 'nowrap'
            }}
          >
            Applied
          </span>
        )}
      </h3>
    </>
  );
}

export default ProfileName;
